import { useCallback, useEffect, useState } from 'react';

const LS_KEY = 'combos_show_timer';
const CHANGE_EVENT = 'combos:showTimerChanged';

const readShowTimerPreference = () => {
    try {
        const raw = localStorage.getItem(LS_KEY);
        return raw === null ? true : raw === 'true';
    } catch (e) {
        return true;
    }
};

const writeShowTimerPreference = (value) => {
    try {
        localStorage.setItem(LS_KEY, String(value));
        window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { showTimer: value } }));
    } catch (e) { /* ignore unavailable local storage */ }
};

// For components that let the player change the preference (the start modals).
export const useShowTimerPreference = () => {
    const [showTimer, setShowTimerState] = useState(readShowTimerPreference);

    const setShowTimer = useCallback((value) => {
        setShowTimerState((current) => {
            const nextValue = typeof value === 'function' ? value(current) : value;
            writeShowTimerPreference(nextValue);
            return nextValue;
        });
    }, []);

    return [showTimer, setShowTimer];
};

// For components that only need to react to the preference (the game board).
export const useShowTimerSetting = () => {
    const [showTimer, setShowTimer] = useState(readShowTimerPreference);

    useEffect(() => {
        const handleChange = (event) => setShowTimer(Boolean(event?.detail?.showTimer));
        window.addEventListener(CHANGE_EVENT, handleChange);
        return () => window.removeEventListener(CHANGE_EVENT, handleChange);
    }, []);

    return showTimer;
};
